export default "__VITE_ASSET__2gKu6n3u__"